export default __webpack_public_path__ + "static/media/group-page.c9ccc135.png";